import {
    RegionsEnum,
    ActuatorsAppUserInputPageAmDocument, ActuatorsAppUserInputPageAmQuery, ActuatorsAppUserInputPageAmQueryVariables,
    ActuatorsAppUserInputPageApDocument, ActuatorsAppUserInputPageApQuery, ActuatorsAppUserInputPageApQueryVariables,
    ActuatorsAppUserInputPageEuDocument, ActuatorsAppUserInputPageEuQuery, ActuatorsAppUserInputPageEuQueryVariables,
} from 'src/generated/operations.ts';
import { DocumentNode } from 'graphql/language/ast';
import { getHomePageConfig } from 'src/actuators/home/HomePageMapping.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';

export type ActuatorsAppUserInputPageData = Omit<
ActuatorsAppUserInputPageEuQuery | ActuatorsAppUserInputPageApQuery | ActuatorsAppUserInputPageAmQuery, '__typename'
>;
export type ActuatorsAppUserInputPageVariables = Omit<
ActuatorsAppUserInputPageEuQueryVariables
| ActuatorsAppUserInputPageApQueryVariables
| ActuatorsAppUserInputPageAmQueryVariables,
'__typename'
>;

export type ActuatorsAppUserInputPageConfig = {
    query: DocumentNode;
    filterConfig: FilterConfig;
}

export const getUserInputPageConfig = (region: RegionsEnum): ActuatorsAppUserInputPageConfig | null => {
    const actuatorsPageConfig = getHomePageConfig(region);
    if (actuatorsPageConfig === null) {
        throw new Error('No Actuators Page Config');
    }
    const { filterConfig: mainUserInputConfig } = actuatorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(ActuatorsAppUserInputPageEuDocument),
            filterConfig: mainUserInputConfig,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(ActuatorsAppUserInputPageApDocument),
            filterConfig: mainUserInputConfig,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(ActuatorsAppUserInputPageAmDocument),
            filterConfig: mainUserInputConfig,
        };
    }
    return null;
};
